import { render, staticRenderFns } from "./DeleteCustomer.vue?vue&type=template&id=22eec052"
import script from "./DeleteCustomer.vue?vue&type=script&lang=js"
export * from "./DeleteCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports